import { DmInlineError } from './DmInlineError';
import { DmModalBody } from './DmModalBody';
import { DmModalFooter } from './DmModalFooter';
import { DmPracticeFormFields } from './DmPracticeFormFields';
import type { DmPracticeCreate } from './useDmPracticeCreate';

export function DmPracticeCreatePane({ create }: { create: DmPracticeCreate }) {
    return (
        <>
            <DmModalBody>
                <h3 className="text-[13px] font-bold text-gray-800">New DM practice</h3>
                <p className="text-[13px] text-gray-600">
                    The practice is created in DM right away, then added to this doctor's practices.
                </p>
                <DmPracticeFormFields
                    form={create.form}
                    onChange={create.setForm}
                    errors={create.errors}
                />
                {create.submitError && <DmInlineError message={create.submitError} />}
            </DmModalBody>
            <DmModalFooter
                onCancel={create.close}
                cancelLabel="Back"
                primaryLabel="Create practice"
                pendingLabel="Creating…"
                onPrimary={create.submit}
                isPending={create.isCreating}
            />
        </>
    );
}
